import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import StatesTab from '../components/PayerMatrix/StatesTab';
import InsurancesTab from '../components/PayerMatrix/InsurancesTab';

const PayerMatrix = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(location.state?.activeTab || 'States');

    useEffect(() => {
        if (location.state?.activeTab) {
            setActiveTab(location.state.activeTab);
        }
    }, [location.state]);
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('');

    return (
        <div className="app-page">
            <div className="pill-tabs">
                <button
                    type="button"
                    className={`pill-tab ${activeTab === 'States' ? 'active' : ''}`}
                    onClick={() => setActiveTab('States')}
                >
                    States
                </button>
                <button
                    type="button"
                    className={`pill-tab ${activeTab === 'Insurances' ? 'active' : ''}`}
                    onClick={() => setActiveTab('Insurances')}
                >
                    Insurances
                </button>
            </div>

            <div
                className="bg-white rounded shadow-sm"
                style={{ width: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
            >
                <div className="app-page-toolbar">
                    <h2 className="app-page-title">{activeTab}</h2>
                    <div className="app-page-toolbar-filters">
                        <div className="app-filter-search-wrap">
                            <FaSearch className="app-filter-search-icon" />
                            <input
                                type="text"
                                className="form-control app-filter-search"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{ width: '220px' }}
                            />
                        </div>
                        {activeTab === 'Insurances' && (
                            <>
                                <select
                                    className="form-select app-filter-select"
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                    style={{ width: '140px' }}
                                >
                                    <option value="">Status</option>
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                </select>
                                <button
                                    className="app-filter-action-btn"
                                    onClick={() => navigate('/payer-matrix/add-insurance')}
                                >
                                    Add New
                                </button>
                            </>
                        )}
                    </div>
                </div>

                {activeTab === 'States' ? (
                    <StatesTab searchTerm={searchTerm} />
                ) : (
                    <InsurancesTab searchTerm={searchTerm} statusFilter={statusFilter} />
                )}
            </div>
        </div>
    );
};

export default PayerMatrix;
